import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgIdentityVerified(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M89.294 31.625H19.275c-2.75 0-4.978 2.166-4.978 4.838v46.55c0 2.672 2.229 4.838 4.978 4.838h70.02c2.749 0 4.978-2.166 4.978-4.838v-46.55c0-2.672-2.23-4.838-4.979-4.838Z"
        fill="#F1F5F9"
      />
      <path
        d="M19.275 31.625h70.02c2.747 0 4.978 2.167 4.978 4.838v6.695H14.297v-6.695c0-2.67 2.23-4.838 4.978-4.838Z"
        fill="#78B441"
      />
      <path
        d="m20.373 51.835-.01 27.16c0 1.603 1.337 2.903 2.986 2.903l24.087.009c1.65 0 2.987-1.299 2.988-2.902l.01-27.16c0-1.603-1.337-2.903-2.986-2.904l-24.087-.008c-1.65 0-2.987 1.299-2.988 2.902Z"
        fill="#A6DBCB"
      />
      <path
        d="M26.186 76.308c0-4.693 3.913-8.486 8.742-8.486 4.83 0 8.732 3.803 8.732 8.495v5.71H26.186v-5.72ZM34.928 66.874c2.684 0 4.859-2.114 4.859-4.722 0-2.608-2.175-4.722-4.86-4.722-2.683 0-4.858 2.114-4.858 4.722 0 2.608 2.175 4.722 4.859 4.722Z"
        fill="#007A5F"
      />
      <path
        d="M13.497 80.74V43.003a.8.8 0 1 1 1.6 0v37.735c0 3.465 2.896 6.311 6.518 6.312h58.03a.801.801 0 0 1 0 1.6h-58.03c-4.463 0-8.118-3.52-8.118-7.912Z"
        fill="#0F172A"
      />
      <path d="M86.964 50.98a.8.8 0 0 1 0 1.6H56.316a.8.8 0 1 1 0-1.6h30.648Z" fill="#78B441" />
      <path
        d="M75.254 78.372a.8.8 0 1 1 0 1.6H56.316a.8.8 0 1 1 0-1.6h18.938ZM86.964 72.683a.8.8 0 0 1 0 1.6H56.316a.8.8 0 1 1 0-1.6h30.648ZM86.964 67.003a.8.8 0 0 1 0 1.6H56.316a.8.8 0 1 1 0-1.6h30.648ZM86.964 56.67a.8.8 0 0 1 0 1.599H56.316a.8.8 0 1 1 0-1.6h30.648Z"
        fill="#B3C0D0"
      />
      <path
        d="M94.273 71.615c6.747 0 12.217-5.315 12.217-11.872 0-6.557-5.47-11.872-12.217-11.872-6.748 0-12.218 5.315-12.218 11.872 0 6.557 5.47 11.872 12.218 11.872Z"
        fill="#78B441"
      />
      <mask
        id="identity-verified_svg__a"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={82}
        y={47}
        width={25}
        height={25}
      >
        <path d="M106.49 47.861H82.055v23.744h24.435V47.861Z" fill="#fff" />
      </mask>
      <g mask="url(#identity-verified_svg__a)">
        <mask
          id="identity-verified_svg__b"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={82}
          y={47}
          width={25}
          height={25}
        >
          <path d="M106.49 47.861H82.055v23.744h24.435V47.861Z" fill="#fff" />
        </mask>
        <g mask="url(#identity-verified_svg__b)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M100.028 58.204a1.167 1.167 0 0 0 0-1.683 1.251 1.251 0 0 0-1.733 0l-5.247 5.099L90.25 58.9a1.251 1.251 0 0 0-1.733 0 1.168 1.168 0 0 0 0 1.684l3.665 3.56a1.251 1.251 0 0 0 1.732 0l6.114-5.94Z"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  )
}
export default wrapIllustration(SvgIdentityVerified)
